export const scanaAccountNumberRegex = /^[0-9, -]{6,16}$/
const leadingZerosRegex = /^0+/
const dashRegex = /-/g

export const parseScanaAccountNumber = (accountNumber: string): string => {
    const dashlessAccountNumber =  accountNumber.replace(dashRegex, '')
    return dashlessAccountNumber.replace(leadingZerosRegex, '')
}
